var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RouteAlive',{attrs:{"include":_vm.routeMatches},on:{"destroyed":_vm.handleDestroyed,"removed":_vm.handleRemoved}})
}
var staticRenderFns = []

export { render, staticRenderFns }